// extracted by mini-css-extract-plugin
module.exports = {"title":"follow-up-questions_title__aNh_O","questionCard":"follow-up-questions_questionCard__Wq1VC","arrowIcon":"follow-up-questions_arrowIcon__48qz7"};